import type { FaireProductEntity } from "../../entity_types/product";

export const p_fth9ynmq4q: FaireProductEntity = {
  token: "p_fth9ynmq4q",
  type: "product",
  name: "GARLIC CHILI CRISP (6OZ.)",
  brandToken: "b_efvu4d6w47",
  brandName: "KariKari",
  imageUrl:
    "https://cdn.faire.com/fastly/36ec7a7205d1a6532d729d577e5eacdb1056acd298746860b7438eef532b805b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0da928f06625401a00be7f42f1db887b261f8ccff0d364b742d4a7929d5b5d96.jpeg",
    "https://cdn.faire.com/fastly/bc255cce92c50ef0f74c9f4ad2cf2f75e3eea0a540fa9857abfaec990b0ee9b5.jpeg",
    "https://cdn.faire.com/fastly/dcaa2b53079d3797ff9f270d58dc63bf1bc49ae6c12b66151a5f008543e15146.jpeg",
    "https://cdn.faire.com/fastly/cd12d396078277660e13edecadcc29fcc9761c5e77821d8ca4c175ac6a43d45b.png",
  ],
  priceDollars: 9,
  description:
    "Crunchy. Spicy. Garlicky. Magic.\n\nMeet your new obsession: KariKari Garlic Chili Crisp. Overflowing with golden garlic, crispy shallots, and crunchy peanuts in rich chili oil, it’s bold, complex, and delivers a craveable crunch that transforms anything it touches.\n\nIf you reach for olive oil for richness and hot sauce for heat, reach for KariKari when you want crunch, umami, and bold flavor — plus savory depth and that addictive “what is this and why is it so good?” factor. Handcrafted in small batches, it’s made for flavor lovers who want more out of every bite.\n\nThis isn’t just another condiment or sauce — it’s your kitchen’s MVP. The champion for all your snacks. Drizzle it over eggs, meats, seafood, noodles, sandwiches, pizza, rice bowls, tinned fish, roasted veg, tinned fish, and even vanilla ice cream! Once you open a jar, there’s no going back.\n\nSpoon it. Drizzle it. Share it. Just don’t be surprised when you’re hooked.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:28.664Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
